var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.831,
    y: 3.716,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 3.57,
    height: 12.091
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.402,
    y: 6.032,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 3.57,
    height: 9.775
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 7.069,15.81 7.928,15.81 19.145,15.81 19.145,9.33 11.364,2.11 6.187,5.946  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 11.408,
    y1: 2.6,
    x2: 11.408,
    y2: 14.935
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.416,
    y1: 7.476,
    x2: 11.798,
    y2: 7.476
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.416,
    y1: 10.257,
    x2: 11.798,
    y2: 10.257
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 13.416,
    y1: 13.037,
    x2: 11.798,
    y2: 13.037
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightFacility);
export default __webpack_public_path__ + "static/media/light-facility.57b260a0cdcdf96475d85b49e85349c7.svg";
export { ForwardRef as ReactComponent };